import { IntegrationProvider } from './IntegrationProvider'
import {
    IntegrationsContainer,
    IntegrationsDescription,
    IntegrationsTitle,
    DescriptionWrapper,
    InfoBannerWrapper,
    LinkButtonWrapper,
} from './integrations.route.styles'
import useIntegrationRoute from './hooks/useIntegrationRoute'
import { InfoBanner } from '@/ui/components/BannerAlert'
import Typography from '@/ui/components/typography'
import { useCustomTheme } from '@/core/theme'

const IntegrationsPage = () => {
    const { integrationsProvidersData } = useIntegrationRoute()
    const theme = useCustomTheme()

    return (
        <IntegrationsContainer>
            <IntegrationsTitle
                data-testid="integrations-page-title"
                variant="xl-regular"
                color={theme.colors.greys[800]}
            >
                Integrations
            </IntegrationsTitle>
            <IntegrationsDescription
                data-testid="integrations-page-description"
                variant="m-regular"
                color={theme.colors.greys[700]}
            >
                To get the most out of At-Bay Stance it's important to connect
                the tools your team uses everyday.
            </IntegrationsDescription>
            <InfoBannerWrapper>
                <InfoBanner
                    data-testid="integrations-page-admin-access-banner"
                    title="Only account admins can set up new integrations due to access restrictions."
                    description={
                        <DescriptionWrapper>
                            <Typography variant="s-regular">
                                By signing up, you acknowledge and agree to the
                                following{' '}
                            </Typography>
                            <LinkButtonWrapper
                                to="https://www.at-bay.com/stance/terms-of-service/"
                                text="terms of service"
                                external={true}
                                withChevron={false}
                                variant="s-regular"
                                className="integrations-terms-of-service"
                            />
                        </DescriptionWrapper>
                    }
                />
            </InfoBannerWrapper>
            {integrationsProvidersData.map(
                ({ icon, description, provider, name }) =>
                    provider && (
                        <IntegrationProvider
                            dataTestId={`integrations-page-${name}-provider-card`}
                            key={name}
                            provider={provider}
                            icon={icon}
                            description={description}
                            name={name}
                        />
                    )
            )}
        </IntegrationsContainer>
    )
}

export default IntegrationsPage
